module.exports = __webpack_public_path__ + "img/Weapon_124.c0cbf50e.png";